import { memo } from "react";
import { useSelector } from "react-redux";
import { useUpdateCheck } from "react-update-notification";
import { flashesSelector } from "store/flashes";
import { flattenDeep } from "utils/helpers";
import ToastsList from "./ToastsList";

const Toasts = () => {
	// redux global state
	const flashes = useSelector(flashesSelector);
	const { status: versionUpdateStatus, reloadPage } = useUpdateCheck({ type: "interval", ignoreServerCache: true });

	return (
		<div
			className="position-absolute end-0 w-100 w-sm-auto w-xl-35 mw-md-75 mw-lg-50 mw-xl-35"
			aria-live="polite"
			aria-atomic="true">
			{flattenDeep(Object.keys(flashes)?.map((type) => [...flashes[type]]))?.length ||
			versionUpdateStatus === "available" ? (
				<ToastsList
					flashes={flashes}
					uiVersionUpdateNeeded={versionUpdateStatus === "available"}
					reloadPage={reloadPage}
				/>
			) : (
				<></>
			)}
		</div>
	);
};

export default memo(Toasts);
